'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobile = exports.getScrollbarWidth = exports.scrollPage = exports.smoothScrollTo = exports.cleanProps = exports.propTypes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _autoBind = require('@zippytech/react-class/autoBind');

var _autoBind2 = _interopRequireDefault(_autoBind);

var _reactNotifyResize = require('@zippytech/react-notify-resize');

var _reactNotifyResize2 = _interopRequireDefault(_reactNotifyResize);

var _reactCleanProps = require('@zippytech/react-clean-props');

var _reactCleanProps2 = _interopRequireDefault(_reactCleanProps);

var _isMobile = require('./isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _smoothScrollTo2 = require('./smoothScrollTo');

var _smoothScrollTo3 = _interopRequireDefault(_smoothScrollTo2);

var _scrollPage2 = require('./scrollPage');

var _scrollPage3 = _interopRequireDefault(_scrollPage2);

var _getScrollbarWidth = require('./getScrollbarWidth');

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _shouldComponentUpdate2 = require('./shouldComponentUpdate');

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _Scrollbar = require('./Scrollbar');

var _Scrollbar2 = _interopRequireDefault(_Scrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var callFn = function callFn(fn) {
  return fn();
};
var raf = global.requestAnimationFrame;

var ua = global.navigator ? global.navigator.userAgent || '' : '';

var IS_EDGE = ua.indexOf('Edge/') !== -1;
var IS_MS_BROWSER = IS_EDGE || ua.indexOf('Trident') !== -1;
var IS_IE = IS_MS_BROWSER && !IS_EDGE;

var WRAPPER_STYLE = {
  overflow: 'hidden',
  // flex-basis auto is needed for Safari.
  // Also, we need flex-shrink 1
  flex: '1 1 auto',
  position: 'relative',
  display: 'flex'
};

var VERTICAL = 'vertical';
var HORIZONTAL = 'horizontal';

var SIZES = {
  vertical: 'height',
  horizontal: 'width'
};

var OTHER_ORIENTATION = {
  vertical: 'horizontal',
  horizontal: 'vertical'
};

var ZippyScrollContainer = function (_Component) {
  _inherits(ZippyScrollContainer, _Component);

  function ZippyScrollContainer(props) {
    _classCallCheck(this, ZippyScrollContainer);

    var _this = _possibleConstructorReturn(this, (ZippyScrollContainer.__proto__ || Object.getPrototypeOf(ZippyScrollContainer)).call(this, props));

    (0, _autoBind2.default)(_this, {
      scrollTop: 1,
      scrollLeft: 1,
      scrollTopMax: 1,
      scrollLeftMax: 1
    });

    _this.state = {
      scrollbars: {
        horizontal: false,
        vertical: false
      }
    };

    if (props.scrollDebounceDelay > 0) {
      _this.onScrollDebounce = (0, _lodash2.default)(_this.onScrollDebounce, props.scrollDebounceDelay, { leading: false });
    }
    _this.onStop = (0, _lodash2.default)(_this.onStop, props.scrollStopDelay, {
      leading: false
    });

    // we assume hideNativeScrollbarIfPossible
    // cannot change for the lifecycle of the component
    _this.nativeScrollbarWidth = (0, _getScrollbarWidth2.default)(_this.props.hideNativeScrollbarIfPossible);

    _this.scroll = {
      scrollTop: 0,
      scrollLeft: 0
    };

    _this.trackSize = {};
    _this.clientSize = {};
    _this.scrollSize = {};
    _this.scrollbars = {};
    _this.scrollerClientSize = {};
    _this.scrollerScrollSize = {};

    _this.scrollbarRef = {
      vertical: function vertical(c) {
        _this.scrollbars.vertical = c;
      },
      horizontal: function horizontal(c) {
        _this.scrollbars.horizontal = c;
      }
    };

    _this.refThis = function (c) {
      _this.domNode = c;
    };

    _this.refWrapper = function (c) {
      if (c) {
        _this.setupWrapperPassiveScrollListener(c);
      } else {
        _this.removeWrapperPassiveScrollListener(_this.wrapperNode);
      }
      _this.wrapperNode = c;
    };
    _this.refView = function (v) {
      _this.viewNode = v;
    };
    _this.refScroller = function (c) {
      if (props.usePassiveScroll) {
        if (c) {
          _this.setupPassiveScrollListener(c);
        } else {
          _this.removePassiveScrollListener(_this.scrollerNode);
        }
      }
      _this.scrollerNode = c;
    };
    return _this;
  }

  // ADJUST WRAPPER ON SCROLL INTO VIEW!!!


  _createClass(ZippyScrollContainer, [{
    key: 'onWrapperScroll',
    value: function onWrapperScroll(event) {
      var _this2 = this;

      var eventTarget = event.target;

      if (eventTarget != this.wrapperNode) {
        return;
      }

      var scrollLeft = eventTarget.scrollLeft,
          scrollTop = eventTarget.scrollTop;

      if (scrollLeft) {
        eventTarget.scrollLeft = 0;

        raf(function () {
          _this2.scrollLeft += scrollLeft;
        });
      }
      if (scrollTop) {
        eventTarget.scrollTop = 0;
        raf(function () {
          _this2.scrollTop += scrollTop;
        });
      }
    }
  }, {
    key: 'setupWrapperPassiveScrollListener',
    value: function setupWrapperPassiveScrollListener(node) {
      node.addEventListener('scroll', this.onWrapperScroll, {
        passive: true
      });
    }
  }, {
    key: 'removeWrapperPassiveScrollListener',
    value: function removeWrapperPassiveScrollListener() {
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.wrapperNode;

      if (node) {
        node.removeEventListener('scroll', this.onWrapperScroll, {
          passive: true
        });
      }
    }
  }, {
    key: 'setupPassiveScrollListener',
    value: function setupPassiveScrollListener(node) {
      node.addEventListener('scroll', this.onScroll, {
        passive: true
      });
    }
  }, {
    key: 'removePassiveScrollListener',
    value: function removePassiveScrollListener() {
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scrollerNode;

      if (node) {
        node.removeEventListener('scroll', this.onScroll, {
          passive: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
      if (this.props.usePassiveScroll) {
        this.removePassiveScrollListener();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _shouldComponentUpdate3.default)(this, nextProps, nextState);
    }
  }, {
    key: 'ensureNonStaticStyle',
    value: function ensureNonStaticStyle(style, domNode) {
      if (!this.props.forceNonStaticPosition) {
        return style;
      }
      style = style || {};
      var _style = style,
          position = _style.position;

      var nonStatic = position == 'relative' || position == 'absolute';

      if (nonStatic) {
        return style;
      }

      if (domNode) {
        position = global.getComputedStyle(domNode).position;
        nonStatic = position == 'relative' || position == 'absolute';

        if (!nonStatic) {
          return _extends({}, style, { position: 'relative' });
        }
      }

      return _extends({}, style, { position: 'relative' });
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var renderScroller = props.renderScroller,
          renderView = props.renderView,
          Factory = props.factory,
          inlineBlock = props.inlineBlock,
          usePassiveScroll = props.usePassiveScroll,
          theme = props.theme,
          contain = props.contain,
          nativeScroll = props.nativeScroll;
      var style = props.style,
          children = props.children;

      var className = props.className || '';

      style = _extends({
        overflow: 'hidden',
        display: props.display ? props.display : inlineBlock ? 'inline-flex' : 'flex',
        flexFlow: 'column'

      }, this.ensureNonStaticStyle(style, this.domNode));

      if (contain) {
        if (contain === true) {
          style.contain = 'style layout paint';
        } else {
          style.contain = contain;
        }
      }

      var factoryProps = (0, _reactCleanProps2.default)(props, ZippyScrollContainer.propTypes);

      className += inlineBlock ? ' zippy-react-scroll-container--inline-block' : ' zippy-react-scroll-container--block';

      className += ' zippy-react-scroll-container';

      if (theme) {
        className += ' zippy-react-scroll-container--theme-' + theme;
      }

      var nativeScrollbarWidth = this.nativeScrollbarWidth;
      var emptyScrollOffset = this.props.emptyScrollOffset;

      var scrollerStyle = {};
      if (this.props.inertialScroll) {
        scrollerStyle.WebkitOverflowScrolling = 'touch';
      }

      if (this.props.scrollerStyle) {
        scrollerStyle = _extends({}, scrollerStyle, this.props.scrollerStyle);
      }
      scrollerStyle.overflow = nativeScroll ? 'auto' : 'scroll';
      scrollerStyle.direction = 'ltr';
      if (!nativeScroll) {
        scrollerStyle.marginRight = -emptyScrollOffset - nativeScrollbarWidth;
        scrollerStyle.marginBottom = -emptyScrollOffset - nativeScrollbarWidth;
      }

      var viewClassName = (this.props.viewClassName || '') + ' zippy-react-scroll-container__view ' + (!nativeScrollbarWidth ? 'zippy-react-scroll-container__view--zero-width-scrollbar' : '');
      var viewChildren = children;

      var viewStyle = {};
      if (this.props.viewStyle) {
        viewStyle = _extends({}, viewStyle, this.props.viewStyle);
      }

      if (!emptyScrollOffset || nativeScroll) {
        viewChildren = children;
      } else {
        viewStyle.paddingRight = emptyScrollOffset;
        var viewChildrenStyle = {
          paddingBottom: emptyScrollOffset
        };
        if (IS_IE) {
          viewChildrenStyle.display = 'inline-block';
        }
        viewChildren = _react2.default.createElement(
          'div',
          { key: 'viewChildren', style: viewChildrenStyle },
          children
        );
      }

      var resizer = !!this.props.resizer;

      var viewProps = {
        ref: this.refView,
        className: viewClassName,
        style: viewStyle,
        children: [viewChildren, resizer && _react2.default.createElement(_reactNotifyResize2.default, {
          ResizeObserver: this.props.ResizeObserver,
          checkResizeDelay: this.props.checkResizeDelay,
          key: 'viewResizer',
          useRaf: this.props.rafOnResize,
          onResize: this.onViewResize,
          notifyOnMount: true
        })]
      };

      var view = renderView ? renderView(viewProps) : _react2.default.createElement('div', _extends({ key: 'view' }, viewProps));

      var scrollerProps = {
        className: 'zippy-react-scroll-container__scroller',
        style: scrollerStyle,
        ref: this.refScroller,
        children: [view, resizer ? _react2.default.createElement(_reactNotifyResize2.default, {
          ResizeObserver: this.props.ResizeObserver,
          checkResizeDelay: this.props.checkResizeDelay,
          useRaf: this.props.rafOnResize,
          key: 'scrollerResizer',
          onResize: this.onResize,
          notifyOnMount: true
        }) : null].filter(Boolean)
      };

      if (!usePassiveScroll) {
        scrollerProps.onScroll = this.onScroll;
      }

      if (this.props.avoidRepaintOnScroll) {
        scrollerProps.className += ' zippy-react-scroll-container__scroller--avoid-repaint';
      }
      if (this.props.hideNativeScrollbarIfPossible) {
        scrollerProps.className += ' zippy-react-scroll-container__scroller--hide-native-scrollbar-if-possible';
      }

      if (this.props.dragToScroll) {
        scrollerProps.tabIndex = -1;
      }

      var scroller = renderScroller ? renderScroller(scrollerProps) : _react2.default.createElement('div', scrollerProps);

      children = [_react2.default.createElement('div', {
        key: 'wrapper',
        className: 'zippy-react-scroll-container__wrapper',
        ref: this.refWrapper,
        style: this.props.wrapperStyle ? _extends({}, WRAPPER_STYLE, this.props.wrapperStyle) : WRAPPER_STYLE,
        children: scroller
      })].concat(_toConsumableArray(this.renderScrollbars()));

      if (this.props.showScrollbarsOnOver) {
        factoryProps.onMouseEnter = this.onMouseEnter;
        factoryProps.onMouseLeave = this.onMouseLeave;
      }

      return Factory ? _react2.default.createElement(Factory, _extends({}, factoryProps, {
        ref: this.refThis,
        style: style,
        className: className,
        children: children
      })) : (0, _react.createElement)(props.tagName, _extends({}, factoryProps, {
        ref: this.refThis,
        style: style,
        className: className,
        children: children
      }));
    }
  }, {
    key: 'onMouseEnter',
    value: function onMouseEnter(event) {
      this.mouseEntered = true;

      this.setScrollbarsVisible({
        horizontal: true,
        vertical: true
      });

      if (this.props.onMouseEnter) {
        this.props.onMouseEnter(event);
      }
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave() {
      this.mouseEntered = false;

      this.setScrollbarsVisible({
        horizontal: false,
        vertical: false
      });

      if (this.props.onMouseLeave) {
        this.props.onMouseLeave(event);
      }
    }
  }, {
    key: 'onViewResize',
    value: function onViewResize(size) {
      if (this.props.onViewResize) {
        this.props.onViewResize(size, this);
      }

      this.rafSync();
    }
  }, {
    key: 'onResize',
    value: function onResize(size) {
      if (this.props.onResize) {
        this.props.onResize(size, this);
      }

      this.rafSync();
    }
  }, {
    key: 'renderScrollbars',
    value: function renderScrollbars() {
      var scrollbars = this.state.scrollbars;

      return [scrollbars.vertical && this.renderScrollbar('vertical', scrollbars), scrollbars.horizontal && this.renderScrollbar('horizontal', scrollbars)];
    }
  }, {
    key: 'renderScrollbar',
    value: function renderScrollbar(orientation, scrollbars) {
      if (this.checkAllowedScrollbars()[orientation] === false) {
        return null;
      }

      var sizeName = SIZES[orientation];
      var nativeScrollbarWidth = this.nativeScrollbarWidth;

      var oppositeVisible = scrollbars[OTHER_ORIENTATION[orientation]];
      var _props = this.props,
          scrollThumbWidth = _props.scrollThumbWidth,
          scrollThumbStartEndRespectMargin = _props.scrollThumbStartEndRespectMargin,
          scrollThumbMargin = _props.scrollThumbMargin;

      var trackSize = this.trackSize[sizeName];

      trackSize -= scrollThumbMargin * (scrollThumbStartEndRespectMargin ? 2 : 1);

      if (oppositeVisible) {
        trackSize -= scrollThumbWidth;
      }

      var emptyScrollOffset = this.props.emptyScrollOffset;

      var scrollbarProps = {
        key: orientation,
        ref: this.scrollbarRef[orientation],
        emptyScrollOffset: emptyScrollOffset,
        nativeScrollbarWidth: nativeScrollbarWidth,
        orientation: orientation,
        visible: !this.props.autoHide,
        autoHide: this.props.autoHide,
        oppositeVisible: oppositeVisible,
        scrollThumbStyle: this.props.scrollThumbStyle,

        trackSize: trackSize,
        scrollSize: this.scrollerScrollSize[sizeName],
        clientSize: this.clientSize[sizeName] + emptyScrollOffset,
        dragToScroll: this.props.dragToScroll,

        scrollThumbMinSize: this.props.scrollThumbMinSize,
        scrollThumbRadius: this.props.scrollThumbRadius,
        scrollThumbStartEndRespectMargin: scrollThumbStartEndRespectMargin,
        scrollThumbOverWidth: this.props.scrollThumbOverWidth,
        scrollThumbWidth: scrollThumbWidth,
        scrollThumbMargin: scrollThumbMargin,
        scrollTrackOverTransitionDuration: this.props.scrollTrackOverTransitionDuration,
        showTrackOnDrag: this.props.showTrackOnDrag,
        alwaysShowTrack: this.props.alwaysShowTrack,
        hideTransitionDuration: this.props.hideTransitionDuration,
        showTransitionDuration: this.props.showTransitionDuration,

        onScrollThumbScrollTop: this.onScrollThumbScrollTop,
        onScrollThumbScrollLeft: this.onScrollThumbScrollLeft,

        onStartDrag: this.props.dragToScroll && this.onScrollbarStartDrag,
        onStopDrag: this.props.dragToScroll && this.onScrollbarStopDrag,

        onWheelScroll: this.onScrollbarWheelScroll,
        onPageScroll: this.onScrollbarPageScroll
      };

      return _react2.default.createElement(_Scrollbar2.default, scrollbarProps);
    }
  }, {
    key: 'onScrollbarStartDrag',
    value: function onScrollbarStartDrag(orientation) {
      if (this.props.onScrollbarStartDrag) {
        this.props.onScrollbarStartDrag(orientation);
      }
      if (orientation == VERTICAL && this.props.onVerticalScrollbarStartDrag) {
        this.props.onVerticalScrollbarStartDrag();
      } else if (this.props.onHorizontalScrollbarStartDrag) {
        this.props.onHorizontalScrollbarStartDrag();
      }
    }
  }, {
    key: 'onScrollbarStopDrag',
    value: function onScrollbarStopDrag(orientation) {
      this.focus();

      if (this.props.onScrollbarStopDrag) {
        this.props.onScrollbarStopDrag(orientation);
      }

      if (orientation == VERTICAL && this.props.onVerticalScrollbarStopDrag) {
        this.props.onVerticalScrollbarStopDrag();
      } else if (this.props.onHorizontalScrollbarStopDrag) {
        this.props.onHorizontalScrollbarStopDrag();
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.getScrollerNode().focus();
    }
  }, {
    key: 'onScrollbarWheelScroll',
    value: function onScrollbarWheelScroll(orientation, delta) {
      var node = this.getScrollerNode();

      var horiz = orientation == 'horizontal';
      var scrollPosName = horiz ? 'scrollLeft' : 'scrollTop';

      var currentValue = node[scrollPosName];
      var newValue = currentValue + delta;

      this.smoothScrollTo(newValue, {
        orientation: orientation,
        duration: 10
      });
    }
  }, {
    key: 'onScrollbarPageScroll',
    value: function onScrollbarPageScroll(orientation, direction) {
      this.focus();

      this.scrollPage(orientation, direction);
    }
  }, {
    key: 'scrollPage',
    value: function scrollPage(orientation, direction) {
      if (!direction) {
        throw new Error('Please provide a scroll direction: 1 or -1!');
      }
      var node = this.getScrollerNode();
      var horiz = orientation == 'horizontal';

      (0, _scrollPage3.default)(node, {
        orientation: orientation,
        direction: direction,
        pageSize: this.clientSize[horiz ? 'width' : 'height'] - 20
      });
    }
  }, {
    key: 'scrollHorizontalPage',
    value: function scrollHorizontalPage(direction) {
      this.scrollPage('horizontal', direction);
    }
  }, {
    key: 'scrollVerticalPage',
    value: function scrollVerticalPage(direction) {
      this.scrollPage('vertical', direction);
    }
  }, {
    key: 'smoothScrollTo',
    value: function smoothScrollTo(newValue, cfg, callback) {
      return (0, _smoothScrollTo3.default)(this.getScrollerNode(), newValue, cfg, callback);
    }
  }, {
    key: 'onScrollThumbScrollTop',
    value: function onScrollThumbScrollTop(pos) {
      this.getScrollerNode().scrollTop = pos;
    }
  }, {
    key: 'onScrollThumbScrollLeft',
    value: function onScrollThumbScrollLeft(pos) {
      this.getScrollerNode().scrollLeft = pos;
    }
  }, {
    key: 'getScrollerNode',
    value: function getScrollerNode() {
      this.scrollerNode = this.scrollerNode || (0, _reactDom.findDOMNode)(this).firstChild.firstChild;
      return this.scrollerNode;
    }
  }, {
    key: 'getScrollerChild',
    value: function getScrollerChild() {
      this.scrollerChild = this.scrollerChild || this.getScrollerNode().firstChild;
      return this.scrollerChild;
    }
  }, {
    key: 'getTrackSize',
    value: function getTrackSize() {
      var node = (0, _reactDom.findDOMNode)(this);
      if (this.props.getTrackSize) {
        return this.props.getTrackSize(node);
      }
      return {
        width: node.clientWidth,
        height: node.clientHeight
      };
    }
  }, {
    key: 'getScrollSize',
    value: function getScrollSize() {
      if (this.props.getScrollSize) {
        return this.props.getScrollSize(this.getScrollerNode());
      }
      var node = this.getScrollerChild();
      return {
        width: node.scrollWidth,
        height: node.scrollHeight
      };
    }
  }, {
    key: 'getClientSize',
    value: function getClientSize() {
      var n = (0, _reactDom.findDOMNode)(this);
      if (this.props.getClientSize) {
        return this.props.getClientSize(n);
      }
      var node = n.firstChild;

      return {
        width: node.clientWidth,
        height: node.clientHeight
      };
    }
  }, {
    key: 'getScrollbars',
    value: function getScrollbars() {
      this.trackSize = this.getTrackSize();
      var scrollSize = this.scrollSize = this.getScrollSize();
      this.clientSize = this.getClientSize();

      var scrollerNode = this.getScrollerNode();
      var scrollerNodeClientSize = this.scrollerClientSize = {
        height: scrollerNode.clientHeight,
        width: scrollerNode.clientWidth
      };
      this.scrollerScrollSize = {
        height: scrollerNode.scrollHeight,
        width: scrollerNode.scrollWidth
      };

      var scrollbars = {
        vertical: scrollSize.height > scrollerNodeClientSize.height,
        horizontal: scrollSize.width > scrollerNodeClientSize.width
      };

      return scrollbars;
    }
  }, {
    key: 'rafSync',
    value: function rafSync(callback) {
      var _this3 = this;

      raf(function () {
        _this3.sync();
        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: 'sync',
    value: function sync() {
      var _this4 = this;

      if (this.unmounted) {
        return;
      }

      var oldScrollbars = this.state.scrollbars;

      var scrollbars = this.getScrollbars();

      this.setState({
        scrollbars: scrollbars
      }, function () {
        if (_this4.props.onScrollbarsChange && (scrollbars.vertical != oldScrollbars.vertical || scrollbars.horizontal != oldScrollbars.horizontal)) {
          _this4.props.onScrollbarsChange(scrollbars);
        }
      });
    }
  }, {
    key: 'hasScrollbar',
    value: function hasScrollbar(orientation) {
      return this.state.scrollbars[orientation];
    }
  }, {
    key: 'hasVerticalScrollbar',
    value: function hasVerticalScrollbar() {
      return this.hasScrollbar(VERTICAL);
    }
  }, {
    key: 'hasHorizontalScrollbar',
    value: function hasHorizontalScrollbar() {
      return this.hasScrollbar(HORIZONTAL);
    }
  }, {
    key: 'onScroll',
    value: function onScroll(event) {
      var eventTarget = event.target;

      if (this.props.onScroll) {
        this.props.onScroll(event);
      }
      if (eventTarget != this.scrollerNode) {
        return;
      }

      this.onScrollDebounce(eventTarget);
    }
  }, {
    key: 'onScrollDebounce',
    value: function onScrollDebounce(eventTarget) {
      var _this5 = this;

      var props = this.props;
      var rafOnScroll = props.rafOnScroll,
          cancelPrevScrollRaf = props.cancelPrevScrollRaf,
          avoidScrollTopBrowserLayout = props.avoidScrollTopBrowserLayout,
          scrollMaxDelta = props.scrollMaxDelta;


      var rafFn = rafOnScroll ? raf : callFn;

      if (this.scrollRafId && rafOnScroll && cancelPrevScrollRaf) {
        global.cancelAnimationFrame(this.scrollRafId);
      }
      this.scrollRafId = rafFn(function () {
        if (_this5.unmounted) {
          return;
        }
        delete _this5.scrollRafId;
        var onScrollStart = props.onScrollStart,
            onScrollStop = props.onScrollStop,
            autoHide = props.autoHide;

        var startStop = !!(onScrollStart || onScrollStop || autoHide || avoidScrollTopBrowserLayout);

        var scrollTop = void 0;
        var scrollLeft = void 0;

        if (!avoidScrollTopBrowserLayout) {
          scrollTop = eventTarget.scrollTop;
          scrollLeft = eventTarget.scrollLeft;
        } else {
          var targetRect = _this5.targetRect || eventTarget.getBoundingClientRect();

          _this5.targetRect = targetRect;
          var viewRect = eventTarget.firstChild.getBoundingClientRect();
          scrollTop = targetRect.top - viewRect.top;
          scrollLeft = targetRect.left - viewRect.left;
        }

        var scrollPos = { scrollTop: scrollTop, scrollLeft: scrollLeft };
        var prevScrollPos = _this5.scroll;

        var prevScrollTop = prevScrollPos.scrollTop,
            prevScrollLeft = prevScrollPos.scrollLeft;


        if (startStop) {
          if (!_this5.scrollStarted) {
            if (onScrollStart) {
              onScrollStart(scrollPos, prevScrollPos, eventTarget);
            }
          }
        }

        var scrollVertical = false;
        var scrollHorizontal = false;

        if (props.onContainerScroll) {
          props.onContainerScroll(scrollPos, prevScrollPos, eventTarget);
        }

        var scrollTopChange = scrollTop != prevScrollTop;

        if (scrollTopChange) {
          scrollVertical = true;
          if (_this5.scrollbars.vertical) {
            _this5.scrollbars.vertical.setScrollPos(scrollTop);
          }
          if (props.onContainerScrollVertical) {
            props.onContainerScrollVertical(scrollTop, prevScrollTop, eventTarget);
          }
          if (props.onContainerScrollVerticalMin && scrollTop == 0) {
            props.onContainerScrollVerticalMin(0, eventTarget);
          }
          if (props.onContainerScrollVerticalMax && (scrollMaxDelta ? scrollTop >= _this5.scrollTopMax - scrollMaxDelta : scrollTop == _this5.scrollTopMax)) {
            props.onContainerScrollVerticalMax(scrollTop);
          }
        }

        var scrollLeftChange = scrollLeft != prevScrollLeft;

        if (scrollLeftChange) {
          scrollHorizontal = true;
          if (_this5.scrollbars.horizontal) {
            _this5.scrollbars.horizontal.setScrollPos(scrollLeft);
          }

          if (props.onContainerScrollHorizontal) {
            props.onContainerScrollHorizontal(scrollLeft, prevScrollLeft, eventTarget);
          }
          if (props.onContainerScrollHorizontalMin && scrollLeft == 0) {
            props.onContainerScrollHorizontalMin(0, eventTarget);
          }
          if (props.onContainerScrollHorizontalMax && (scrollMaxDelta ? scrollLeft >= _this5.scrollLeftMax - scrollMaxDelta : scrollLeft == _this5.scrollLeftMax)) {
            props.onContainerScrollHorizontalMax(scrollLeft, eventTarget);
          }
        }

        // the scroll event could be called with the same values,
        // in which case we could enter an infinite loop in the onStop method,
        // so we're protecting against this
        if (startStop && (scrollTopChange || scrollLeftChange)) {
          if (!_this5.scrollStarted || _this5.scrollStarted.vertical != scrollVertical || _this5.scrollStarted.horizontal != scrollHorizontal) {
            _this5.lazyShowScrollbars();

            _this5.scrollStarted = {
              horizontal: scrollHorizontal,
              vertical: scrollVertical
            };
          }

          _this5.onStop(scrollPos, prevScrollPos, eventTarget);
        }

        _this5.scroll = scrollPos;
      });
    }
  }, {
    key: 'getContainerTargetNode',
    value: function getContainerTargetNode() {
      var view = this.viewNode;

      return !this.props.emptyScrollOffset ? view : view.firstChild;
    }
  }, {
    key: 'lazyShowScrollbars',
    value: function lazyShowScrollbars() {
      if (this.props.autoHide) {
        setTimeout(this.showScrollbars, this.props.showDelay);
      }
    }
  }, {
    key: 'onStop',
    value: function onStop(scrollPos, prevScrollPos, eventTarget) {
      this.scrollStarted = false;

      delete this.targetRect;
      if (this.props.onScrollStop) {
        this.props.onScrollStop(scrollPos, prevScrollPos, eventTarget);
      }

      setTimeout(this.hideScrollbars, this.props.hideDelay);
    }
  }, {
    key: 'showScrollbars',
    value: function showScrollbars() {
      if (this.props.autoHide && this.scrollStarted) {
        var _scrollbars = this.scrollbars,
            horizontal = _scrollbars.horizontal,
            vertical = _scrollbars.vertical;
        var _scrollStarted = this.scrollStarted,
            scrollHorizontal = _scrollStarted.horizontal,
            scrollVertical = _scrollStarted.vertical;


        var visibleScrollbars = {};
        if (scrollHorizontal) {
          visibleScrollbars.horizontal = true;
        }
        if (scrollVertical) {
          visibleScrollbars.vertical = true;
        }

        this.setScrollbarsVisible(visibleScrollbars);
      }
    }
  }, {
    key: 'checkAllowedScrollbars',
    value: function checkAllowedScrollbars() {
      var result = {
        vertical: true,
        horizontal: true
      };

      var scrollbars = this.props.scrollbars;

      if (scrollbars === false) {
        result.vertical = false;
        result.horizontal = false;
      }
      if ((typeof scrollbars === 'undefined' ? 'undefined' : _typeof(scrollbars)) == 'object') {
        if (scrollbars.horizontal === false) {
          result.horizontal = false;
        }
        if (scrollbars.false === false) {
          result.false = false;
        }
      }

      var shouldAllowScrollbars = this.props.shouldAllowScrollbars;


      if (typeof shouldAllowScrollbars == 'function') {
        var shouldAllow = shouldAllowScrollbars(this.props, (0, _getScrollbarWidth2.default)());

        if (shouldAllow === false || shouldAllow && shouldAllow.horizontal === false) {
          result.horizontal = false;
        }

        if (shouldAllow === false || shouldAllow && shouldAllow.vertical === false) {
          result.vertical = false;
        }
      }

      return result;
    }
  }, {
    key: 'setScrollbarsVisible',
    value: function setScrollbarsVisible(scrollbars) {
      var horizontalVisible = scrollbars.horizontal,
          verticalVisible = scrollbars.vertical;
      var _scrollbars2 = this.scrollbars,
          horizontal = _scrollbars2.horizontal,
          vertical = _scrollbars2.vertical;


      if (horizontalVisible !== undefined && horizontal) {
        horizontal.setVisible(horizontalVisible);
      }
      if (verticalVisible !== undefined && vertical) {
        vertical.setVisible(verticalVisible);
      }
    }
  }, {
    key: 'hideScrollbars',
    value: function hideScrollbars() {
      if (this.props.showScrollbarsOnOver && this.mouseEntered) {
        return;
      }
      if (this.props.autoHide && !this.scrollStarted) {
        this.setScrollbarsVisible({ horizontal: false, vertical: false });
      }
    }
  }, {
    key: 'scrollTop',
    set: function set(value) {
      this.getScrollerNode().scrollTop = value;
    },
    get: function get() {
      return this.scroll.scrollTop;
    }
  }, {
    key: 'scrollLeft',
    set: function set(value) {
      this.getScrollerNode().scrollLeft = value;
    },
    get: function get() {
      return this.scroll.scrollLeft;
    }
  }, {
    key: 'scrollTopMax',
    get: function get() {
      if (!this.scrollerScrollSize.height || !this.scrollerClientSize.height) {
        this.getScrollbars();
      }
      return this.scrollerScrollSize.height - this.scrollerClientSize.height;
    }
  }, {
    key: 'scrollLeftMax',
    get: function get() {
      if (!this.scrollerScrollSize.width || !this.scrollerClientSize.width) {
        this.getScrollbars();
      }
      return this.scrollerScrollSize.width - this.scrollerClientSize.width;
    }
  }]);

  return ZippyScrollContainer;
}(_react.Component);

exports.default = ZippyScrollContainer;


ZippyScrollContainer.defaultProps = {
  shouldAllowScrollbars: function shouldAllowScrollbars(props, scrollbarWidth) {
    if (props.nativeScroll) {
      return false;
    }
    if (!scrollbarWidth) {
      return false;
    }
  },
  avoidRepaintOnScroll: true,
  avoidScrollTopBrowserLayout: false,
  alwaysShowTrack: false,
  autoHide: true,
  cancelPrevScrollRaf: true,
  contain: false,
  dragToScroll: true,
  emptyScrollOffset: _isMobile2.default ? 15 : IS_IE ? 0 : (0, _getScrollbarWidth2.default)(),
  forceNonStaticPosition: false,
  hideDelay: 400,
  hideTransitionDuration: '300ms',
  inertialScroll: true,
  inlineBlock: false,
  rafOnScroll: false,
  rafOnResize: false,
  scrollDebounceDelay: 0,
  resizer: true,
  scrollStopDelay: 180,
  scrollThumbMargin: 2,
  scrollThumbStartEndRespectMargin: true,
  scrollThumbWidth: 7,
  scrollThumbOverWidth: 10,
  scrollThumbRadius: 3,
  showDelay: 100,
  showScrollbarsOnOver: true,
  showTransitionDuration: '100ms',
  showTrackOnDrag: false,
  scrollTrackOverTransitionDuration: '100ms',
  usePassiveScroll: true,
  tagName: 'div',
  theme: 'default'
};

var propTypes = {
  alwaysShowTrack: _propTypes2.default.bool,
  avoidScrollTopBrowserLayout: _propTypes2.default.bool,
  avoidRepaintOnScroll: _propTypes2.default.bool,
  autoHide: _propTypes2.default.bool,
  cancelPrevScrollRaf: _propTypes2.default.bool,
  dragToScroll: _propTypes2.default.bool,
  display: _propTypes2.default.string,
  checkResizeDelay: _propTypes2.default.number,
  emptyScrollOffset: _propTypes2.default.number,
  factory: _propTypes2.default.func,
  nativeScroll: _propTypes2.default.bool,
  forceNonStaticPosition: _propTypes2.default.bool,
  hideDelay: _propTypes2.default.number,
  getClientSize: _propTypes2.default.func,
  getScrollSize: _propTypes2.default.func,
  getTrackSize: _propTypes2.default.func,

  hideTransitionDuration: _propTypes2.default.string,
  hideNativeScrollbarIfPossible: _propTypes2.default.bool,

  inertialScroll: _propTypes2.default.bool,

  inlineBlock: _propTypes2.default.bool,
  rafOnResize: _propTypes2.default.bool,
  contain: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),

  onContainerScroll: _propTypes2.default.func,
  onContainerScrollHorizontal: _propTypes2.default.func,
  onContainerScrollHorizontalMax: _propTypes2.default.func,
  onContainerScrollHorizontalMin: _propTypes2.default.func,
  onContainerScrollVertical: _propTypes2.default.func,
  onContainerScrollVerticalMax: _propTypes2.default.func,
  onContainerScrollVerticalMin: _propTypes2.default.func,

  onResize: _propTypes2.default.func,
  onScroll: _propTypes2.default.func,
  onScrollbarsChange: _propTypes2.default.func,
  onScrollStart: _propTypes2.default.func,
  onScrollStop: _propTypes2.default.func,
  onViewResize: _propTypes2.default.func,

  rafOnScroll: _propTypes2.default.bool,
  scrollDebounceDelay: _propTypes2.default.number,
  renderScroller: _propTypes2.default.func,
  renderView: _propTypes2.default.func,
  resizer: _propTypes2.default.bool,
  scrollbars: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    vertical: _propTypes2.default.bool,
    horizontal: _propTypes2.default.bool
  })]),
  usePassiveScroll: _propTypes2.default.bool,
  showScrollbarsOnOver: _propTypes2.default.bool,
  onScrollbarStartDrag: _propTypes2.default.func,
  onScrollbarStopDrag: _propTypes2.default.func,
  onHorizontalScrollbarStartDrag: _propTypes2.default.func,
  onHorizontalScrollbarStopDrag: _propTypes2.default.func,
  onVerticalScrollbarStartDrag: _propTypes2.default.func,
  onVerticalScrollbarStopDrag: _propTypes2.default.func,
  scrollerStyle: _propTypes2.default.shape({}),
  scrollStopDelay: _propTypes2.default.number,
  scrollThumbMargin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  scrollMaxDelta: _propTypes2.default.number,
  scrollThumbMinSize: _propTypes2.default.number,
  scrollThumbOverWidth: _propTypes2.default.number,
  scrollThumbRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  scrollThumbStartEndRespectMargin: _propTypes2.default.bool,
  scrollThumbWidth: _propTypes2.default.number,
  scrollThumbStyle: _propTypes2.default.shape(),
  scrollTrackOverTransitionDuration: _propTypes2.default.string,
  showDelay: _propTypes2.default.number,
  showTrackOnDrag: _propTypes2.default.bool,
  shouldComponentUpdate: _propTypes2.default.func,
  shouldAllowScrollbars: _propTypes2.default.func,
  showTransitionDuration: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  theme: _propTypes2.default.string,
  viewClassName: _propTypes2.default.string,
  viewStyle: _propTypes2.default.shape({}),
  wrapperStyle: _propTypes2.default.shape({}),
  ResizeObserver: _propTypes2.default.func
};

ZippyScrollContainer.propTypes = propTypes;

exports.propTypes = propTypes;
exports.cleanProps = _reactCleanProps2.default;
exports.smoothScrollTo = _smoothScrollTo3.default;
exports.scrollPage = _scrollPage3.default;
exports.getScrollbarWidth = _getScrollbarWidth2.default;
exports.isMobile = _isMobile2.default;